import React, { useEffect, useContext, useState } from 'react';
import {
  params,
  shape,
  string,
  arrayOf,
  number,
  useDataModel,
} from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useCustomerInfo } from '../hooks/useCustomerInfo';
import { EmptyCard } from './address-card-states/empty-card';
import { ErrorCard } from './address-card-states/error-card';
import { LoadingCard } from './address-card-states/loading-card';
import { AddressDataCard } from './address-card-states/address-data-card';

const ShippingAddressCard = () => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('shipping-address-card.ready');
  }, []);
  const { svocID, userID } = useCustomerInfo();
  const { channel } = useContext(ExperienceContext);
  const [initialLoading, setInitialLoading] = useState(true);
  const channelId = channel === 'mobile' ? 2 : 1;

  const { loading, data, error, refetch } = useDataModel('userAddresses', {
    variables: { channelId, customerAccountId: svocID, userId: userID },
    skip: !userID || !svocID,
    ssr: false,
    context: { withAuth: true },
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (!loading && initialLoading) {
      setInitialLoading(false);
    }
  }, [loading, initialLoading]);

  const hasErrors = error || data?.errors;
  const hasDefaultAddress = data?.userAddresses?.defaultAddress;
  const isLoading = initialLoading || loading;

  const handleRefresh = () => {
    refetch();
  };

  if (isLoading) {
    return <LoadingCard />;
  }

  if (hasErrors && !hasDefaultAddress) {
    return <ErrorCard onRefresh={handleRefresh} />;
  }

  if (!data?.userAddresses?.defaultAddress) {
    return <EmptyCard />;
  }

  return <AddressDataCard address={data?.userAddresses?.defaultAddress} />;
};

ShippingAddressCard.displayName = 'ShippingAddressCard';

ShippingAddressCard.dataModel = {
  userAddresses: params({
    userId: string().isRequired(),
    customerAccountId: string().isRequired(),
    channelId: number().isRequired(),
  }).shape({
    defaultAddress: shape({
      name: shape({
        firstName: string(),
        lastName: string(),
        nickName: string(),
      }),
      postalDetails: shape({
        addressLine1: string(),
        addressLine2: string(),
        city: string(),
        state: string(),
        zipCode: string(),
      }),
      phones: arrayOf(
        shape({
          number: string(),
          primaryFlag: string(),
        })
      ),
      companyName: string(),
    }),
  }),
};

export { ShippingAddressCard };
